<div id="overlay-shadow-container" class="overlay-shadow-container flex-centered" [style.z-index]="ZIndex" [style.position]="Position" *ngIf="IsOverlayShadowVisible">
	<ng-content></ng-content>
</div>
